import {
  Box,
  CustomLinkButton,
  LocalMallRounded,
  MuiLoadingButton,
  Typography,
} from "components/common";
import { SliderCardWrapper, StarTag } from "./index.styled";
import { useState } from "react";
import { Link } from "react-router-dom";
import useFunctions from "layouts/authed-layout/ts/useFunctions";
import { Skeleton } from "@mui/material";

interface SliderCardProps {
  loading?: boolean;
  data?: {
    id: number;
    title: string;
    images: string[];
    thumbnail: string;
    retail_price: number;
    wholesale_price: number;
  };
  index?: number;
}

export default function SliderCard({ loading, data, index }: SliderCardProps) {
  const { dealerSwitch } = useFunctions();

  const [imgLoading, setImgLoading] = useState<boolean>(true);
  const handleImageLoad = () => {
    setImgLoading(false);
  };
  return (
    <SliderCardWrapper loading={imgLoading}>
      {data === undefined ? (
        <Box className="main">
          <Box sx={{ aspectRatio: "1/1" }}>
            <Skeleton width="100%" height="100%" />
          </Box>
          <Box mt={1}>
            <Typography className="title" fontSize="16px" variant="subtitle2">
              <Skeleton width="150px" />
            </Typography>
          </Box>
          <Typography
            sx={{
              mt: 1,
              color: "#00E852",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            <Skeleton width="50px" />
          </Typography>

          <CustomLinkButton
            disabled
            sx={{
              width: "100%",
              mt: 2,
            }}
          >
            <Skeleton width="100px" />
          </CustomLinkButton>
        </Box>
      ) : (
        <Box className="main">
          <Box
            component={(props: any) => (
              <Link
                to={`/product-details/${data.id}`}
                style={{ textDecoration: "none" }}
              >
                {props.children}
              </Link>
            )}
          >
            <Box className="img-container">
              {index !== undefined && index < 6 && (
                <StarTag>
                  New Model
                </StarTag>
              )}
              {index === 6 && (
                <StarTag>
                  Special Sale
                </StarTag>
              )}


              {Array.isArray(data.images)
                ? (data.images[0]?.includes('.mp4')
                  ? <Box
                    component="video"
                    src={data.images[0]}
                    autoPlay
                    muted
                    loop
                    playsInline
                    onLoad={handleImageLoad}
                  />
                  : <Box
                    component="img"
                    src={data.images[0]}
                    alt={data.images[0]}
                    onLoad={handleImageLoad}
                  />)
                : (data.thumbnail?.includes('.mp4')
                  ? <Box
                    component="video"
                    src={data.thumbnail}
                    autoPlay
                    muted
                    loop
                    playsInline
                    onLoad={handleImageLoad}
                  />
                  : <Box
                    component="img"
                    src={data.thumbnail}
                    alt={data.thumbnail}
                    onLoad={handleImageLoad}
                  />)
              }

            </Box>

            <Box>
              <Typography className="title" fontSize="16px" variant="subtitle2">
                {data.title}
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "#00E852",
                fontSize: "18px",
                fontWeight: "600",
              }}
            >
              ${dealerSwitch ? data.wholesale_price : data.retail_price}
            </Typography>
          </Box>
          <MuiLoadingButton
            startIcon={<LocalMallRounded />}
            sx={{
              width: "100%",
              mt: 2,
            }}
          // onClick={() =>
          //   addToCart({
          //     id,
          //     price: dealerSwitch ? wholesale_price : retail_price,
          //     title,
          //     data,
          //     quantity: 1,
          //     subtotal: dealerSwitch ? wholesale_price : retail_price,
          //   })
          // }
          >
            Add to cart
          </MuiLoadingButton>
        </Box>
      )}
    </SliderCardWrapper>
  );
}
